(function() {
  angular.module('common')
  .factory('printService', ['$resource', function($resource) {
    return $resource('',{},{
      print:  {method: 'POST', url: '/printDocument', isArray:false, headers: {'Accept': 'application/pdf'}, responseType: 'arraybuffer',
          transformResponse: function (pdfdata, headers) {  
        	  let serviceUnavailable = headers('x-service-unavailable');
              return {
                 document: serviceUnavailable ? undefined : new Blob([pdfdata], {type: 'application/pdf'}),
                 serviceUnavailable: serviceUnavailable
              };
            }
         }
    });
  }])
  .factory('pdfPrintUtility', ['$filter', function ($filter) {
    var lastPosColonRegex = /:$/;
    var seeDetails = "- see details below";

    function replaceColon(val) {
      return val ? val.replace(lastPosColonRegex,"") : '';
    }

    function cleanseText(val) {
       if (val) {
         val = val.replace(seeDetails,"").trim();
       }
       return val;
    }

    function parseLabelAndText(element) {
      let field = $(element).find("label:first").text();
      let value = $(element).find("p:first").text();
      return field ? {'name': replaceColon(field).split(' ').join(''), 'value' : cleanseText(value)} : '';
    }

    function parseDescriptionList(descriptionList, retainColon) {
    	if (retainColon == undefined){
    		retainColon = true;
    	}
    	let termsAndDescriptions = [];
        let terms = descriptionList.find("span:not('.ng-hide, .hidden') dt");
      $.each(terms, function(index, element) {
    	  let term = cleanseText($(element).text());
    	  if(!retainColon){
    		  term = replaceColon(term);
    	  }
          let description = $(element).nextUntil("dt").filter("dd");
          var descText = '';
          $.each(description, function(index, desc) {
        	  descText = (descText.concat(' ', cleanseText(desc.outerText))).trim();
          });
          termsAndDescriptions.push({'Name': term, 'Description' : descText });
      });
      return descriptionList && descriptionList.attr('id') ? {'name': $filter('capitalize')(descriptionList.attr('id')) , 'value': termsAndDescriptions } : '';
    }

    function parseTable(table) {
      let theaders = table.find("th");
      let fields = [];
      $.each(theaders,function(index, theader) {
         let header = $(theader).text().trim();
          fields.push(header ? header.split(' ').join('') : '');
      });

      let values = [];
      $.each(table.find("tr"), function(index, row) {
          let value = {};
          $.each($(row).find("td"), function(index, column) {
            if (fields[index]) {
              value[fields[index]] = cleanseText($(column).text());
            }
          });
          if (!(_.isEmpty(value))) {
        	  values.push(value);
          }
      });
      return values.length > 0 ? values : '';
    }

    function parseUiGrid(grid) {
      let theaders = grid.find("span.ui-grid-header-cell-label");
      let fields = [];
      $.each(theaders,function(index, theader) {
         let header = $(theader).text();
          fields.push(header ? header.replace("/","").split(' ').join('') : '');
      });

      let values = [];
      $.each(grid.find("div.ui-grid-row"), function(index, row) {
          let value = {};
          $.each($(row).find("div.ui-grid-cell-contents"), function(index, column) {
            if (fields[index]) {
              value[fields[index]] = cleanseText($(column).text());
            }
          });
          if (!(_.isEmpty(value))) {
        	  values.push(value);
          }
      });
      return values.length > 0 ? values : '';
    }

    function getPrintableTextByIds(idList) {
    	idList = angular.isArray(idList) ? idList: [idList]
      let printableTexts = {};
      _.each(idList, function(id) {
          printableTexts[$filter('capitalize')(id)] = cleanseText($("#"+id + ".printable:not('.ng-hide, .hidden')").text());
      });
      return printableTexts;
    }

    function getPrintableUiGrid(gridId) {
        let printableGrid = {};
        var grid = $("div.grid.printable#"+gridId).first();
        if (grid) {
          let printables = parseUiGrid($(grid));
          if (printables) {
            printableGrid[ $filter('capitalize')(gridId)] = printables;
          }
        }
        return printableGrid;
    }

    function getPrintableTable(tableId) {
      let printableTable = {};
      var table = $("table.printable#"+tableId).first();
      if (table) {
        let printables = parseTable($(table));
        if (printables) {
          printableTable[ $filter('capitalize')(tableId)] = printables;
        }
      }
      return printableTable;
    }

    function getPrintableDescriptionList(sectionId) {
      let printableLists= {};

      var descLists = $("#"+sectionId+" dl.printable").toArray();
      $.each(descLists, function(index, element) {
        let printables = parseDescriptionList($(element));
        if (printables) {
          printableLists[printables.name] = printables.value;
        }
      });
      return printableLists;
    }

    function getPrintableSection(sectionId){
      let printableSection = {};
      var printableFields = $("#"+sectionId+" div.printable").toArray();
      $.each(printableFields,function(index, element){
        let printable = parseLabelAndText(element);
        if (printable) {
          printableSection[printable.name] = printable.value;
        }
      });
      return printableSection;
    }
    
    function getPrintableAccordion(accordionId,cateId, fields){
        let printableAccordion = {}; 
        var accordion = $("#"+accordionId+" div.benefit-category-data."+cateId).toArray();
        if (accordion) {
          let printables = parseAccordion($(accordion), fields);
          if (printables) {
              printableAccordion[ $filter('capitalize')(accordionId)] = printables;
          }
        }
        return printableAccordion;
        
    }
    
    function parseAccordion(accordion, fields) {
        let values = {};
        let tValues = accordion.find("div.printable:not('.hidden, .ng-hide')");
        $.each(tValues, function(index, row) {
            var rowParent = $( row ).parent( "div:not('.ng-hide, .hidden')" );
            if(rowParent && rowParent.length>0){
	            let field = $filter('filter')(fields, {'name': row.id});
	            if (field && field.length>0) {
	                values[field[0].name] = cleanseText(row.textContent);
	            }
            }
        });
        return _.isEmpty(values) ? '': values;
      }
    
    return {
      getPrintableSection: getPrintableSection,
      getPrintableDescriptionList: getPrintableDescriptionList,
      getPrintableTextByIds: getPrintableTextByIds,
      getPrintableTable: getPrintableTable,
      getPrintableUiGrid: getPrintableUiGrid,
      getPrintableAccordion: getPrintableAccordion

    };

  }]);
})();
